import { Pipe, PipeTransform } from '@angular/core';
import {ArtistSummary} from '../model/ArtistSummary';
import { AlbumSummaryWithArtist } from '../model/AlbumSummaryWithArtist';
@Pipe({
  name: 'filterByAlbum'
})
export class FilterByAlbumPipe implements PipeTransform {

  transform(items: AlbumSummaryWithArtist[], searchText: string): AlbumSummaryWithArtist[] {
    if (!items) {
      return [];
    }
    if (!searchText) {
      return items;
    }
    searchText = searchText.toLowerCase();

    return items.filter( album => {
      return album.name.toLowerCase().includes(searchText) || 
             album.year.toString().includes(searchText) || 
             album.artist.name.toLowerCase().includes(searchText);
    });
  }
}
